module.exports = __webpack_public_path__ + "static/slide2-strength-152634fed2e2d28bc6c6890a61305f51.jpg";